// extracted by mini-css-extract-plugin
export default {"wrapper":"CompanyContainer_wrapper__gFFXg","container":"CompanyContainer_container__w6LM1"};